<template>
  <div class="flex flex-col items-center justify-center py-8">
    <div
      v-html="RANDOM_SHAPES_ICON"
      class="text-primary-purple w-10 h-10"
    ></div>
    <span class="text-black text-xxl font-semibold leading-9 text-left"
      >Create New Booking System Layouts</span
    >
    <BaseButton
      type="button"
      class="bg-primary-purple max-w-max px-8 text-white p-2 rounded-md font-inter text-base font-medium leading-6"
      @click="$emit('createNew')"
    >
      Create
    </BaseButton>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BaseButton from "@/components/shared/BaseButton.vue";
import { RANDOM_SHAPES_ICON } from "@/assets/svg/shared/svg-constants";

export default defineComponent({
  name: "EmptyState",
  components: {
    BaseButton,
  },
  emits: ["createNew"],
  setup() {
    return {
      RANDOM_SHAPES_ICON,
    };
  },
});
</script>
